import { createAction, props } from '@ngrx/store';

// Add Data
export const addRecord = createAction(
    '[Data] Add record support-request',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record support-request success'
);
export const addRecordFailure = createAction(
    '[Data] Add record support-request failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state support-request',
);